import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiAlert } from "@ryde/controls";

import { BulkBookingsUnaffiliatedUnitsAlertStyled } from "./bulk-bookings.styled";

export const UnaffiliatedUnitsAlert: FC = () => {
  const { t } = useTranslation();

  return (
    <BulkBookingsUnaffiliatedUnitsAlertStyled>
      {/* MuiAlert defaults to the assertive role="alert"; this warning follows the user's own edits. */}
      <MuiAlert severity="warning" role="status" aria-live="polite">
        {t("booking.PASSENGERS_FROM_UNAFFILIATED_UNITS")}
      </MuiAlert>
    </BulkBookingsUnaffiliatedUnitsAlertStyled>
  );
};
